import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Mentor } from '../model/mentor.model'
import { MentorAuthService } from '../services/mentor-auth.service'
import { environment } from 'src/environments/environment'
import { BehaviorSubject, Subject, of } from 'rxjs';
@Injectable()
export class MentorService {
    private meetingDetailsSubject = new Subject<any>();
    meetingDetails$ = this.meetingDetailsSubject.asObservable();
    mentor: Mentor
    mentors: Mentor[]
    constructor(private http: HttpClient, private mentorAuthSrevice: MentorAuthService) { }
    // baseUrl="http://localhost:4000/mentorship-api/mentor"
    // sharedUrl="http://localhost:4000/mentorship-api/meetings/"
    baseUrl= `${environment.baseUrl}mentor/`
    // sharedUrl = environment.baseUrl
    public register(data) {
        // return this.http.post(this.baseUrl + 'mentor/register', data)
        return this.http.post(this.baseUrl + 'register', data)
    }
    public getMentors() {
        return this.http.get(this.baseUrl)
    }
    public updateMentor(data) {
        return this.http.put(this.baseUrl, data)
    }
    public deleteMentor(id) {
        // return this.http.delete(this.baseUrl + 'mentor/' + id)

        return this.http.delete(this.baseUrl + id)
    }
    
    public saveFeedback(feedback) {
        // return this.http.post(this.baseUrl + 'mentor/add/feedback', feedback)
        return this.http.post(this.baseUrl + 'add/feedback', feedback)
    }
    public getAssignedScholars() {
        return this.http.get(this.baseUrl + 'scholars/' + this.mentorAuthSrevice.getLoggedUserId())
    }
    public getGroupTasks(){
        return this.http.get(this.baseUrl + 'group-tasks/' + this.mentorAuthSrevice.getLoggedUserId())
    }
    public getGroupTaskDetailsById(groupMeetingId){
        return this.http.get(this.baseUrl + 'group-task-details/' + groupMeetingId);
    }
    public getFeedbackByMentorIdAndScholarID(mentorid, scholarid) {
        // return this.http.get(this.baseUrl + 'mentor/feedbacks',{
        //         params: {
        //             mentorid: mentorid,
        //             scholarid: scholarid
        //         }
        //     })
        return this.http.get(this.baseUrl + 'feedbacks',{
            params: {
                mentorid: mentorid,
                scholarid: scholarid
            }
        })
    }
    public getFeedbackById(id) {
        return this.http.get(this.baseUrl + 'feedbackbyid/' + id)
    }
    public deleteTaskNote(taskId){
        return this.http.delete(this.baseUrl+'deleteTaskNote/'+ taskId)
    }
    deleteTaskDocument(documentId){
        return this.http.delete(this.baseUrl+'deleteTaskDocument/'+ documentId)
    }
    deleteGroupTask(meetingId){
     return this.http.delete(`${this.baseUrl}deleteGroupTask/${meetingId}`);
    }
    public updateTaskNote(details,noteId){
        return this.http.patch(this.baseUrl+'updateTaskNote/'+noteId,{details})
    }
    public editDocument(details,documentId){
        return this.http.patch(this.baseUrl+'updateTaskDocument/'+documentId,{details})
    }
    public getCountries() {
        return ['Afghanistan',
            'Albania',
            'Algeria',
            'Andorra',
            'Angola',
            'Antigua and Barbuda',
            'Armenia',
            'Australia',
            'Austria',
            'Azerbaijan',
            'Bahamas',
            'Bahrain',
            'Bangladesh',
            'Barbados',
            'Belarus',
            'Belgium',
            'Belize',
            'Benin',
            'Bhutan',
            'Bosnia and Herzegovina',
            'Botswana',
            'Brazil',
            'Brunei',
            'Bulgaria',
            'Burkina Faso',
            'Burundi',
            'Cabo Verde',
            'Cambodia',
            'Cameroon',
            'Canada',
            'Central African Republic',
            'Chile',
            'China',
            'Colombia',
            'Comoros',
            'Congo',
            'Costa Rica',
            'Cote dIvoire',
            'Croatia',
            'Cuba',
            'Cyprus',
            'Czechia',
            'Denmark',
            'Djibouti',
            'Dominica',
            'Dominican Republic',
            'Ecuador',
            'Egypt',
            'El Salvador',
            'Equatorial Guinea',
            'Eritrea',
            'Estonia',
            'Eswatini',
            'Ethiopia',
            'Fiji',
            'Finland',
            'France',
            'Gabon',
            'Gambia',
            'Georgia',
            'Germany',
            'Ghana',
            'Greece',
            'Grenada',
            'Guatemala',
            'Guinea',
            'Guinea-Bissau',
            'Guyana',
            'Haiti',
            'Honduras',
            'Hungary',
            'Iceland',
            'India',
            'Indonesia',
            'Iran',
            'Iraq',
            'Ireland',
            'Israel',
            'Italy',
            'Jamaica',
            'Japan',
            'Jordan',
            'Kazakhstan',
            'Kenya',
            'Kiribati',
            'Kosovo',
            'Kuwait',
            'Kyrgyzstan',
            'Laos',
            'Latvia',
            'Lebanon',
            'Lesotho',
            'Liberia',
            'Libya',
            'Liechtenstein',
            'Lithuania',
            'Luxembourg',
            'Madagascar',
            'Malawi',
            'Malaysia',
            'Maldives',
            'Mali',
            'Malta',
            'Marshall Islands',
            'Mauritania',
            'Mauritius',
            'Mexico',
            'Micronesia',
            'Moldova',
            'Monaco',
            'Mongolia',
            'Montenegro',
            'Morocco',
            'Mozambique',
            'Myanmar',
            'Namibia',
            'Nauru',
            'Nepal',
            'Netherlands',
            'New Zealand',
            'Nicaragua',
            'Niger',
            'Nigeria',
            'North Korea',
            'North Macedonia',
            'Norway',
            'Oman',
            'Pakistan',
            'Palau',
            'Palestine',
            'Panama',
            'Papua New Guinea',
            'Paraguay',
            'Peru',
            'Philippines',
            'Poland',
            'Portugal',
            'Qatar',
            'Republic of the Congo',
            'Romania',
            'Russia',
            'Rwanda',
            'Saint Kitts and Nevis',
            'Saint Lucia',
            'Saint Vincent and the Grenadines',
            'Samoa',
            'San Marino',
            'Sao Tome and Principe',
            'Saudi Arabia',
            'Senegal',
            'Serbia',
            'Seychelles',
            'Sierra Leone',
            'Singapore',
            'Slovakia',
            'Slovenia',
            'Solomon Islands',
            'Somalia',
            'South Africa',
            'South Korea',
            'South Sudan',
            'Spain',
            'Sri Lanka',
            'Sudan',
            'Suriname',
            'Sweden',
            'Switzerland',
            'Syria',
            'Taiwan',
            'Tajikistan',
            'Tanzania',
            'Thailand',
            'Timor-Leste',
            'Togo',
            'Tonga',
            'Trinidad and Tobago',
            'Tunisia',
            'Turkey',
            'Turkmenistan',
            'Tuvalu',
            'Uganda',
            'Ukraine',
            'United Arab Emirates ',
            'United Kingdom ',
            'United States of America ',
            'Uruguay',
            'Uzbekistan',
            'Vanuatu',
            'Vatican City ',
            'Venezuela',
            'Vietnam',
            'Yemen',
            'Zambia',
            'Zimbabwe'];
    }

  updateMeetingDetails(meetingDetails: any) {
    this.meetingDetailsSubject.next(meetingDetails);
  }
}
